<template>
  <div>
    <!-- <h4 class="border-b pd-b-3 mg-t-less mg-b-3">หลักสูตร {{ courseName }}</h4> -->
    <div v-for="(item, indexSubject) in subjectsList" :key="item.subjectId">
      <el-collapse
        v-model="activeAdjunct"
        class="not-border-t pd-b-4"
        :class="indexSubject == 0 ? '' : 'pd-t-3'"
      >
        <el-collapse-item :name="indexSubject">
          <template slot="title">
            <div
              :class="{
                'opacity-05':
                  notDuringStudy(
                    item.durationTime.open,
                    item.durationTime.close
                  ) || statusCourse == 3,
              }"
              class="flex-display ai-baseline close-arrow"
            >
              <div>
                <div class="circle-collapse">
                  <i
                    v-if="isOpenAdjunct(indexSubject)"
                    class="fas fa-chevron-up"
                  ></i>
                  <i v-else class="fas fa-chevron-down"></i>
                </div>
              </div>
              <div class="subject-title mg-y-4">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="`วิชาที่ ${item.index} ${item.name}`"
                  placement="bottom-start"
                >
                  <h4 class="mg-y-less text-font-16 message-over clamp2">
                    วิชาที่ {{ item.index }} {{ item.name }}
                  </h4>
                </el-tooltip>
              </div>
            </div>
          </template>

          <div>
            <span
              class="text-font-12 color-gray pd-l-2"
              :class="{
                'opacity-05':
                  notDuringStudy(
                    item.durationTime.open,
                    item.durationTime.close
                  ) || statusCourse == 3,
              }"
            >
              <span
                v-if="Date.now() < new Date(item.durationTime.open).getTime()"
              >
                <i class="fas fa-clock"></i>
                เปิดวิชาวันที่ {{ item.durationTime.open | dateTimeTh }}
              </span>

              <span
                v-else-if="
                  new Date().setHours(0, 0, 0, 0) <=
                  new Date(item.durationTime.close).getTime()
                "
              >
                <i class="fas fa-exclamation-triangle"></i>
                ปิดวิชาวันที่
                {{
                  new Date(item.durationTime.close).setHours(23, 59, 59)
                    | dateTimeTh
                }}
              </span>

              <span v-else>
                <i class="fas fa-exclamation-triangle"></i>
                ปิดแล้ว
              </span>
            </span>
            <div
              v-for="(adjunct, indexAdjunct) in getAdjunctList(item)"
              :key="indexAdjunct"
              class="flex-display ai-center"
              :class="{
                'opacity-05':
                  opacityAdjunct(item, adjunct, indexAdjunct) ||
                  statusCourse == 3,
              }"
            >
              <div>
                <div class="success-box">
                  <i
                    v-if="approvetake(item.subjectId, adjunct)"
                    class="fas fa-check-circle color-success text-font-18"
                  ></i>
                </div>
              </div>
              <div class="cursor-pointer pd-l-5">
                <div
                  class="circle-adjunct"
                  :class="{
                    'cursor-not-allowed': closeAction(
                      item,
                      adjunct,
                      indexAdjunct
                    ),
                  }"
                  @click="
                    closeAction(item, adjunct, indexAdjunct) ||
                    statusCourse == 3
                      ? null
                      : actionTake(adjunct, item.subjectId, item.name)
                  "
                  :style="`background-color: ${
                    adjunct.type == 'file' || adjunct.type == 'qa'
                      ? '#00b2ff'
                      : '#ffb800'
                  };`"
                >
                  <i v-if="adjunct.type == 'file'" class="fas fa-file-alt"></i>
                  <i v-if="adjunct.type == 'video'" class="fas fa-play"></i>
                  <i v-if="adjunct.type == 'qa'" class="fas fa-comment-alt"></i>
                </div>
              </div>

              <p
                @click="
                  closeAction(item, adjunct, indexAdjunct) || statusCourse == 3
                    ? null
                    : actionTake(adjunct, item.subjectId, item.name)
                "
                class="pd-l-4 cursor-pointer text-font-16"
                :class="{
                  'cursor-not-allowed':
                    closeAction(item, adjunct, indexAdjunct) ||
                    statusCourse == 3,
                }"
              >
                <el-tooltip
                  v-if="adjunct.type == 'video' && adjunct.durationTime"
                  class="item"
                  effect="dark"
                  :content="
                    Date.now() < new Date(adjunct.durationTime.open).getTime()
                      ? `เปิดเรียนหัวข้อวันที่ ${$options.filters.dateTimeTh(
                          adjunct.durationTime.open
                        )}`
                      : new Date().setHours(0, 0, 0, 0) <=
                        new Date(adjunct.durationTime.close).getTime()
                      ? `ปิดเรียนหัวข้อวันที่ ${$options.filters.dateTimeTh(
                          new Date(adjunct.durationTime.close).setHours(
                            23,
                            59,
                            59
                          )
                        )}`
                      : `ปิดเรียนหัวข้อแล้วยังสามารถดูวีดีโอต่อได้แต่จะไม่นับคะแนน`
                  "
                  placement="bottom-start"
                >
                  <span
                    ><span class="text-weight-bold"
                      >หัวข้อที่ {{ adjunct.index }} </span
                    >{{ adjunct.name }}</span
                  >
                </el-tooltip>
                <el-tooltip
                  v-else-if="
                    (adjunct.id == 'preTest' || adjunct.id == 'postTest') &&
                    adjunct.durationTime
                  "
                  class="item"
                  effect="dark"
                  :content="
                    Date.now() < new Date(adjunct.durationTime.open).getTime()
                      ? `เปิดแบบ${
                          adjunct.id == 'preTest' ? 'ก่อนเรียน' : 'หลังเรียน'
                        }วันที่ ${$options.filters.dateTimeTh(
                          adjunct.durationTime.open
                        )}`
                      : new Date().setHours(0, 0, 0, 0) <=
                        new Date(adjunct.durationTime.close).getTime()
                      ? `ปิดเแบบ${
                          adjunct.id == 'preTest' ? 'ก่อนเรียน' : 'หลังเรียน'
                        }วันที่ ${$options.filters.dateTimeTh(
                          new Date(adjunct.durationTime.close).setHours(
                            23,
                            59,
                            59
                          )
                        )}`
                      : `ปิดแบบทดสอบ${
                          adjunct.id == 'preTest' ? 'ก่อนเรียน' : 'หลังเรียน'
                        }แล้ว`
                  "
                  placement="bottom-start"
                >
                  <span>{{ adjunct.name }}</span>
                </el-tooltip>
                <span v-else>{{ adjunct.name }}</span>
              </p>
            </div>
            <div>
              <div
                v-for="document in item.document"
                :key="document.file"
                class="flex-display ai-center"
                :class="{
                  'opacity-05': closeActionAttach(item),
                }"
              >
                <div>
                  <div class="success-box"></div>
                </div>
                <div
                  class="cursor-pointer pd-l-5"
                  :class="{
                    'cursor-not-allowed': closeActionAttach(item),
                  }"
                >
                  <div
                    class="circle-adjunct"
                    :style="`background-color: ${'#00B27D'};`"
                  >
                    <i class="fas fa-file-alt"></i>
                  </div>
                </div>
                <a
                  :href="
                    closeActionAttach(item)
                      ? null
                      : `${urlCouse}${courseId}/${document.file}`
                  "
                  target="_blank"
                  class="pd-l-4 cursor-pointer text-font-16 color-black learn"
                  :class="{
                    'cursor-not-allowed': closeActionAttach(item),
                  }"
                >
                  {{ document.default }}
                </a>
              </div>
            </div>
            <div>
              <div
                v-for="attach in item.attach"
                :key="attach.file"
                class="flex-display ai-center"
                :class="{
                  'opacity-05': closeActionAttach(item),
                }"
              >
                <div>
                  <div class="success-box"></div>
                </div>
                <div
                  class="cursor-pointer pd-l-5"
                  :class="{
                    'cursor-not-allowed': closeActionAttach(item),
                  }"
                >
                  <div
                    class="circle-adjunct"
                    :style="`background-color: ${'#00B27D'};`"
                  >
                    <i class="fas fa-play"></i>
                  </div>
                </div>
                <a
                  :href="
                    closeActionAttach(item)
                      ? null
                      : `${urlCouse}${courseId}/${attach.file}`
                  "
                  target="_blank"
                  class="pd-l-4 cursor-pointer text-font-16 color-black learn"
                  :class="{
                    'cursor-not-allowed': closeActionAttach(item),
                  }"
                >
                  {{ attach.default }}
                </a>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>

    <div
      v-if="subjectSuccess"
      class="flex-display ai-center pd-b-4"
      :class="{
        'opacity-05': notSuccessAll() || taksAssessment || statusCourse == 3,
      }"
    >
      <div v-if="taksAssessment">
        <div class="success-box">
          <i class="fas fa-check-circle color-success text-font-18"></i>
        </div>
      </div>
      <div
        class="cursor-pointer pd-l-5"
        :class="{
          'cursor-not-allowed': notSuccessAll() || statusCourse == 3,
        }"
      >
        <div class="circle-adjunct" :style="`background-color: ${'#00b2ff'};`">
          <!-- #00B27D -->
          <i class="fas fa-file-alt"></i>
        </div>
      </div>
      <p
        @click="
          notSuccessAll() || statusCourse == 3
            ? null
            : $router.push(
                `/feedback?courseId=${courseId}&subjectId=${$route.query.subjectId}`
              )
        "
        class="pd-l-4 cursor-pointer text-font-16"
        :class="{
          'cursor-not-allowed': notSuccessAll() || statusCourse == 3,
        }"
      >
        แบบประเมินหลักสูตร {{ courseName }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    subjectsList: {
      type: Array,
      default() {
        return [];
      },
    },
    takes: {
      type: Array,
      default() {
        return [];
      },
    },
    courseId: {
      type: String,
      default() {
        return "";
      },
    },
    courseName: {
      type: String,
      default() {
        return "";
      },
    },
    collapse: {
      type: Array,
      default() {
        return [0];
      },
    },
    countPostTest: {
      type: Number,
      default() {
        return 0;
      },
    },
    roundPostTest: {
      type: Array,
      default() {
        return [];
      },
    },
    assessment: {
      type: Array,
      default() {
        return [];
      },
    },
    subjectSuccess: {
      type: Boolean,
      default() {
        return false;
      },
    },
    taksAssessment: {
      type: Boolean,
      default() {
        return false;
      },
    },
    statusCourse: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user() {
      return this.$store.state.user;
    },
  },
  data() {
    return {
      checked: [],
      activeAdjunct: [],
      urlCouse: process.env.VUE_APP_BASE_URL_FILE_COURSE,
    };
  },
  watch: {
    collapse() {
      this.setCollapse();
    },
  },
  mounted() {
    this.setCollapse();
  },
  methods: {
    setCollapse() {
      this.activeAdjunct = this.collapse;
    },
    isOpenAdjunct(id) {
      let filter = this.activeAdjunct.filter((filter) => filter == id);
      return filter.length > 0 ? true : false;
    },
    getAdjunctList(subject) {
      let arr = [];
      if (subject.preTest) {
        arr.push({
          id: "preTest",
          name: "แบบทดสอบก่อนเรียน (Pre-test)",
          type: "file",
          durationTime: subject.durationTimePreTest,
        });
      }

      for (let index = 0; index < subject.topics.length; index++) {
        arr.push({
          id: `video${index}`,
          _id: subject.topics[index]._id,
          index: subject.topics[index].index,
          name: subject.topics[index].topic,
          attach: subject.topics[index].attach,
          durationTime: subject.topics[index].durationTime,
          type: "video",
        });
      }
      if (subject.discussion) {
        arr.push({
          id: "qa",
          name: "กระดานถาม - ตอบระหว่างเรียน (Discussion Forum)",
          type: "qa",
        });
      }

      if (subject.assignment) {
        arr.push({
          id: "assignment",
          name: "งานที่ได้รับมอบหมาย (Assignment)",
          type: "file",
        });
      }

      if (subject.postTest) {
        arr.push({
          id: "postTest",
          name: "แบบทดสอบหลังเรียน (Post-Test)",
          type: "file",
          durationTime: subject.durationTimePostTest,
        });
      }

      return arr;
    },
    actionTake(data, subjectId, subjectName) {
      if (data.id == "preTest" && !this.approvetake(subjectId, data)) {
        this.$router.push(
          `/course/test?courseId=${this.courseId}&subjectId=${subjectId}&type=preTest`
        );
      } else if (data.id == "postTest") {
        this.$router.push(
          `/course/test?courseId=${this.courseId}&subjectId=${subjectId}&type=postTest`
        );
      } else if (data.type == "video") {
        this.$emit("setTopic", data, subjectId);
      } else if (data.id == "qa") {
        this.$router.push(
          `/discussion/forum?courseId=${this.courseId}&subjectId=${subjectId}`
        );
      } else if (data.id == "assignment") {
        this.$router.push(
          `/assignment?courseId=${this.courseId}&subjectId=${subjectId}`
        );
      }
    },
    approvetake(id, adjunct) {
      if (this.user && this.user.role > 0) {
        return false;
      }

      let subject = this.takes.filter((filter) => filter.subjectId == id);

      if (subject.length == 0) {
        return false;
      }

      if (adjunct.id == "preTest") {
        return subject[0].preTest.length > 0 ? true : false;
      } else if (adjunct.id == "postTest") {
        return subject[0].postTest.length > 0 ? true : false;
      } else if (adjunct.type == "video") {
        let video = [];
        let topic = [];

        if (subject.length > 0) {
          topic = subject[0].topic.filter(
            (filter) => filter.actionTo == adjunct._id
          );
        }

        if (topic.length > 0) {
          video = [];
          video = topic.sort((a, b) => {
            if (
              new Date(a["updatedAt"]).getTime() >
              new Date(b["updatedAt"]).getTime()
            ) {
              return -1;
            }
            return 0;
          });
        }

        if (
          video.length > 0 &&
          typeof video[0].percent != "undefined" &&
          (video[0].percent >= 70 ||
            video[0].actionTo === "63bbd123d04c0f0012c5eb93")
        ) {
          return true;
        } else {
          return false;
        }
      } else if (adjunct.id == "qa") {
        return subject[0].discussion;
      } else if (adjunct.id == "assignment") {
        return subject[0].assignment.length > 0 ? true : false;
      }
    },
    setSubjectFile(attach, subjectId) {
      this.$emit("setSubjectFile", attach, subjectId);
    },
    notDuringStudy(open, close) {
      if (this.user && this.user.role > 0) {
        return false;
      }

      if (
        new Date().setHours(0, 0, 0, 0) >= new Date(open).getTime() &&
        new Date().setHours(0, 0, 0, 0) <= new Date(close).getTime()
      ) {
        return false;
      } else {
        return true;
      }
    },
    notWorkPreTest(subjectId, adjunct) {
      if (this.user && this.user.role > 0) {
        return false;
      }

      if (adjunct.id == "preTest") {
        return false;
      } else {
        return !this.approvetake(subjectId, { id: "preTest" });
      }
    },
    notAllowVideo(subjectId, adjunct) {
      if (this.user && this.user.role > 0) {
        return false;
      }

      let subject = this.takes.filter(
        (filter) => filter.subjectId == subjectId
      );

      if (adjunct.type != "video" && adjunct.id != "preTest") {
        let topic = [];

        if (subject.length == 0) {
          return false;
        }

        if (subject.length > 0) {
          topic = subject[0].topic;
        }

        let all = [];
        topic.map((item) => {
          let pass =
            item.percent >= 70 || item.actionTo === "63bbd123d04c0f0012c5eb93"
              ? 1
              : 0;
          all.push(pass);
        });

        return Math.min(...all) == 1 ? false : false;
      } else {
        return false;
      }
    },
    closeAction(subject, adjunct, indexAdjunct) {
      if (this.user && this.user.role > 0) {
        return false;
      }

      let notDuringStudy = this.notDuringStudy(
        subject.durationTime.open,
        subject.durationTime.close
      );

      let notDuringTopic = false;
      if (adjunct.type == "video") {
        notDuringTopic = this.notDuringStudy(
          adjunct.durationTime.open,
          adjunct.durationTime.close
        );
      }

      let notWorkPreTest = this.notWorkPreTest(subject.subjectId, adjunct);

      let notAllowVideo = this.notAllowVideo(subject.subjectId, adjunct);

      let notAllowPreTest =
        adjunct.id == "preTest" && this.approvetake(subject.subjectId, adjunct);

      let postTestFull =
        this.countPostTest != 0 && adjunct.id == "postTest"
          ? this.getRoundPostTest(subject.subjectId) >= this.countPostTest
          : false;
      let notOpenVideo =
        adjunct.type == "video" &&
        adjunct.durationTime.open &&
        Date.now() < new Date(adjunct.durationTime.open).getTime();

      if (
        (notDuringStudy && adjunct.type != "video") ||
        notOpenVideo ||
        notWorkPreTest ||
        notAllowVideo ||
        notAllowPreTest ||
        postTestFull
      ) {
        return true;
      } else {
        return false;
      }
    },
    closeActionAttach(subject) {
      if (this.user && this.user.role > 0) {
        return false;
      }

      let subjectFilter = this.takes.filter(
        (filter) => filter.subjectId == subject.subjectId
      );

      let notWorkPreTest =
        subjectFilter.length > 0 && subjectFilter[0].preTest.length > 0
          ? false
          : true;

      if (notWorkPreTest) {
        return true;
      } else {
        return false;
      }
    },
    opacityAdjunct(subject, adjunct, indexAdjunct) {
      if (this.user && this.user.role > 0) {
        return false;
      }

      let notDuringStudy = this.notDuringStudy(
        subject.durationTime.open,
        subject.durationTime.close
      );

      let notWorkPreTest = this.notWorkPreTest(subject.subjectId, adjunct);
      let approvetake = this.approvetake(subject.subjectId, adjunct);

      let notAllowVideo = this.notAllowVideo(subject.subjectId, adjunct);

      let notOpenVideo =
        adjunct.type == "video" &&
        adjunct.durationTime.open &&
        Date.now() < new Date(adjunct.durationTime.open).getTime();

      if (
        notDuringStudy ||
        notOpenVideo ||
        notWorkPreTest ||
        approvetake ||
        notAllowVideo
      ) {
        return true;
      } else {
        return false;
      }
    },
    getRoundPostTest(id) {
      let filter = this.roundPostTest.filter(
        (filter) => filter.subjectId == id
      );
      return filter.length > 0 ? filter[0].round : 0;
    },
    notSuccessAll() {
      if (this.user && this.user.role > 0) {
        return false;
      }

      let success = [];

      this.subjectsList.map((item) => {
        let adjunctList = this.getAdjunctList(item);
        adjunctList.map((adjunct) => {
          let approvetake = this.approvetake(item.subjectId, adjunct);
          if (approvetake) {
            success.push(1);
          } else {
            success.push(0);
          }
        });
      });

      return Math.min(...success) == 0 || this.assessment.length == 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

.circle-collapse {
  width: 30px;
  height: 30px;
  border: 1px solid $--color-secondary;
  border-radius: 100%;
  color: $--color-secondary;
  display: flex;
  align-items: center;
  justify-content: center;
}
.success-box {
  width: 25px;
  display: flex;
}
.subject-title {
  padding-left: 11px;
}
</style>
